import { CheckboxListFormik } from '@strata/react-checkbox-list';
import { PhoneInputFormik, TextInputFormik } from '@strata/react-inputs';
import { SuggestSingleSelectFormik } from '@strata/react-selects';
import { useFormikContext } from 'formik';
import { type ComponentProps } from 'react';
import type * as Yup from 'yup';

import { IntakeSource, IntakeSourceOptions } from 'services/constants';
import {
    type FormSections,
    type IntakeFormSectionSchemas,
} from 'store/intakeForm/intakeFormSchema';

type Section = typeof FormSections.POINT_OF_CONTACT;

interface PointOfContactInputsProps {
    disabled?: boolean;
    intakeSourceRef?: ComponentProps<typeof SuggestSingleSelectFormik>['inputRef'];
}

export const PointOfContactInputs = ({
    disabled = false,
    intakeSourceRef = undefined,
}: PointOfContactInputsProps) => {
    const formik = useFormikContext<Yup.InferType<(typeof IntakeFormSectionSchemas)[Section]>>();
    return (
        <>
            <SuggestSingleSelectFormik
                id="intakeSource"
                label="Intake Source"
                required
                disabled={disabled}
                inputRef={intakeSourceRef}
                values={IntakeSourceOptions.filter(
                    ({ value }) => value !== IntakeSource.TREATMENT_REQUIRES_PA,
                )}
                onChange={(newVal) => {
                    void formik.setFieldValue('intakeSource', newVal?.value);
                }}
                selectedItem={IntakeSourceOptions.find(
                    ({ value }) => value === formik.values.intakeSource,
                )}
            />
            <div className="sds_intake-form-section__row">
                <TextInputFormik
                    id="contactFirstName"
                    label="First Name"
                    required
                    disabled={disabled}
                />
                <TextInputFormik
                    id="contactLastName"
                    label="Last Name"
                    required
                    disabled={disabled}
                />
            </div>
            <div className="sds_intake-form-section__row">
                <PhoneInputFormik
                    id="contactPhoneNumber"
                    label="Phone Number"
                    required
                    disabled={disabled}
                />
                <PhoneInputFormik id="contactFaxNumber" label="Fax Number" disabled={disabled} />
                <TextInputFormik id="contactEmail" label="Email" disabled={disabled} />
            </div>
            <TextInputFormik
                id="contactOfficeName"
                label="Office Name"
                required
                disabled={disabled}
            />
            <CheckboxListFormik
                name="urgent"
                label="Priority"
                disabled={disabled}
                options={['Urgent']}
                values={formik.values.urgent ? ['Urgent'] : []}
                onChange={(values) => {
                    void formik.setFieldValue('urgent', values.length === 1);
                }}
            />
        </>
    );
};
